import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Search } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        <div className="text-8xl font-display font-bold text-muted-foreground/20 mb-4">
          404
        </div>
        <h1 className="text-title font-display text-primary mb-4">
          Page not found
        </h1>
        <p className="text-muted-foreground mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 px-6 py-3 rounded-lg font-medium bg-secondary text-secondary-foreground hover:bg-secondary/90 transition-all"
          >
            <Home className="w-5 h-5" />
            Go Home
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 px-6 py-3 rounded-lg font-medium border border-border hover:bg-muted transition-all"
          >
            <Search className="w-5 h-5" />
            Start Research
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
